import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if (!d) return '—'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<1?'just now':m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }

const JOB_TYPES = {
  vulnerability_scan: { icon:'🔍', label:'Vulnerability Scan',    color:'#dc2626', bg:'#fee2e2' },
  patch_enforce:      { icon:'⊞',  label:'Enforce Patches',       color:'#1d4ed8', bg:'#dbeafe' },
  profile_apply:      { icon:'⚙️',  label:'Apply Profile',         color:'#7c3aed', bg:'#ede9fe' },
  remote_action:      { icon:'⚡',  label:'Remote Action',         color:'#d97706', bg:'#fef3c7' },
  file_deploy:        { icon:'📦',  label:'Deploy File',           color:'#0891b2', bg:'#cffafe' },
  collect_inventory:  { icon:'🗂',  label:'Collect Inventory',     color:'#16a34a', bg:'#dcfce7' },
  custom_command:     { icon:'⌨',   label:'Custom Command',        color:'#64748b', bg:'#f1f5f9' },
};

const STATUS_META = {
  running: { color:'#7c3aed', bg:'#ede9fe', label:'Running'  },
  success: { color:'#16a34a', bg:'#dcfce7', label:'Success'  },
  failed:  { color:'#dc2626', bg:'#fee2e2', label:'Failed'   },
  partial: { color:'#d97706', bg:'#fef3c7', label:'Partial'  },
};

const DEFAULTS = { name:'', description:'', type:'patch_enforce', schedule:'manual', config:{severity:['critical','high']}, targetDevices:null };

export default function Jobs({ user }) {
  const [jobs,     setJobs]     = useState([]);
  const [runs,     setRuns]     = useState({});
  const [loading,  setLoading]  = useState(true);
  const [msg,      setMsg]      = useState({ text:'', type:'' });
  const [showForm, setShowForm] = useState(false);
  const [form,     setForm]     = useState(DEFAULTS);
  const [saving,   setSaving]   = useState(false);
  const [running,  setRunning]  = useState(null);
  const [runsModal,setRunsModal]= useState(null);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }

  const load = useCallback(async () => {
    try { const r = await axios.get('/api/jobs', auth()); setJobs(r.data); }
    catch(e) { flash(e.response?.data?.error||'Failed to load','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(()=>{ load(); },[load]);

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post('/api/jobs', form, auth());
      flash('Job created'); setShowForm(false); setForm(DEFAULTS); load();
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); }
    finally { setSaving(false); }
  }

  async function runNow(job) {
    setRunning(job.id);
    try {
      const r = await axios.post(`/api/jobs/${job.id}/run`, {}, auth());
      flash(`Job started: ${r.data.message}`); load();
    } catch(e) { flash(e.response?.data?.error||'Failed to run','error'); }
    finally { setRunning(null); }
  }

  async function del(id) {
    if (!window.confirm('Delete this job?')) return;
    try { await axios.delete(`/api/jobs/${id}`, auth()); flash('Deleted'); load(); }
    catch(e) { flash('Failed','error'); }
  }

  async function showRuns(job) {
    try {
      const r = await axios.get(`/api/jobs/${job.id}/runs`, auth());
      setRunsModal({ job, runs: r.data });
    } catch(e) { flash('Failed to load runs','error'); }
  }

  return (
    <div style={{padding:'24px'}}>
      {msg.text && <div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h2 style={{margin:0,fontSize:20,fontWeight:700,color:'#1e293b'}}>Jobs</h2>
          <p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Recurring task templates — scan, patch, profile, collect, command on a schedule</p>
        </div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer',fontSize:14}}>+ New Job</button>
      </div>

      {/* Job type cards overview */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:10,marginBottom:24}}>
        {Object.entries(JOB_TYPES).map(([id,m])=>(
          <div key={id} style={{background:m.bg,borderRadius:10,padding:'12px 14px',cursor:'pointer'}} onClick={()=>{setForm({...DEFAULTS,type:id});setShowForm(true);}}>
            <div style={{fontSize:22,marginBottom:4}}>{m.icon}</div>
            <div style={{fontWeight:700,fontSize:12,color:m.color}}>{m.label}</div>
          </div>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> :
      jobs.length===0 ? (
        <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40,marginBottom:12}}>⏰</div><div style={{fontWeight:600}}>No jobs yet</div><div style={{fontSize:14,marginTop:8}}>Click a job type above or "+ New Job" to create one</div></div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(360px,1fr))',gap:14}}>
          {jobs.map(j=>{
            const jm = JOB_TYPES[j.type]||{icon:'⚡',label:j.type,color:'#64748b',bg:'#f1f5f9'};
            return (
              <div key={j.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
                <div style={{display:'flex',gap:12,marginBottom:10,alignItems:'flex-start'}}>
                  <div style={{width:40,height:40,borderRadius:9,background:jm.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>{jm.icon}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:14,color:'#1e293b'}}>{j.name}</div>
                    {j.description && <div style={{fontSize:12,color:'#64748b',marginTop:1}}>{j.description}</div>}
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0}}>
                    <span style={{background:jm.bg,color:jm.color,borderRadius:5,padding:'2px 7px',fontSize:10,fontWeight:700}}>{jm.label}</span>
                    <span style={{background:'#f1f5f9',color:'#475569',borderRadius:5,padding:'2px 7px',fontSize:10,fontWeight:700,textTransform:'capitalize'}}>{j.schedule}</span>
                  </div>
                </div>
                <div style={{display:'flex',gap:20,marginBottom:12,fontSize:12,color:'#64748b'}}>
                  <span>▶ {j.runCount||0} run(s)</span>
                  <span>🕐 Last: {ts(j.lastRunAt)}</span>
                  {j.nextRunAt && j.schedule!=='manual' && <span>⏭ Next: {ts(j.nextRunAt)}</span>}
                </div>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={()=>runNow(j)} disabled={running===j.id} style={{flex:1,background:running===j.id?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:7,padding:'8px',fontSize:12,fontWeight:600,cursor:running===j.id?'default':'pointer'}}>
                    {running===j.id?'Running...':'▶ Run Now'}
                  </button>
                  <button onClick={()=>showRuns(j)} style={{flex:1,background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:7,padding:'8px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#475569'}}>📋 History</button>
                  <button onClick={()=>del(j.id)} style={{background:'#fee2e2',border:'none',borderRadius:7,padding:'8px 10px',fontSize:12,cursor:'pointer',color:'#dc2626'}}>🗑</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Create modal */}
      {showForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:520,maxWidth:'95vw',maxHeight:'85vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Job</h3>
            <form onSubmit={save}>
              {[['Name*','name'],['Description','description']].map(([l,k])=>(
                <div key={k} style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                </div>
              ))}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Job Type</label>
                  <select value={form.type} onChange={e=>setForm({...form,type:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    {Object.entries(JOB_TYPES).map(([id,m])=><option key={id} value={id}>{m.icon} {m.label}</option>)}
                  </select></div>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Schedule</label>
                  <select value={form.schedule} onChange={e=>setForm({...form,schedule:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    <option value="manual">Manual only</option>
                    <option value="hourly">Hourly</option>
                    <option value="daily">Daily (02:00)</option>
                    <option value="weekly">Weekly (Mon 02:00)</option>
                    <option value="monthly">Monthly (1st 02:00)</option>
                  </select></div>
              </div>

              {/* Type-specific config */}
              {form.type==='patch_enforce' && (
                <div style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:6}}>Patch Severities to Enforce</label>
                  <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
                    {['critical','high','medium','low'].map(s=>(
                      <label key={s} style={{display:'flex',alignItems:'center',gap:6,fontSize:13}}>
                        <input type="checkbox" checked={(form.config?.severity||[]).includes(s)} onChange={e=>{const cur=form.config?.severity||[];setForm({...form,config:{...form.config,severity:e.target.checked?[...cur,s]:cur.filter(x=>x!==s)}});}} />
                        <span style={{textTransform:'capitalize'}}>{s}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {form.type==='custom_command' && (
                <div style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Command</label>
                  <input value={form.config?.command||''} onChange={e=>setForm({...form,config:{...form.config,command:e.target.value}})} placeholder="e.g. gpupdate /force" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,fontFamily:'monospace',boxSizing:'border-box'}} />
                </div>
              )}
              {form.type==='remote_action' && (
                <div style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Action Type</label>
                  <select value={form.config?.type||'reboot'} onChange={e=>setForm({...form,config:{...form.config,type:e.target.value}})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    <option value="reboot">Reboot</option><option value="lock_screen">Lock Screen</option><option value="message">Send Message</option>
                  </select>
                </div>
              )}

              <div style={{marginBottom:20}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Target Devices</label>
                <select value={JSON.stringify(form.targetDevices)} onChange={e=>setForm({...form,targetDevices:JSON.parse(e.target.value)})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                  <option value="null">All Online Devices</option>
                  <option value='{"ring":"test"}'>Test Ring Only</option>
                  <option value='{"ring":"pilot"}'>Pilot Ring Only</option>
                  <option value='{"ring":"production"}'>Production Ring Only</option>
                  <option value='{"os":"windows"}'>Windows Only</option>
                  <option value='{"os":"linux"}'>Linux Only</option>
                </select>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create Job'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Runs history modal */}
      {runsModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,width:580,maxWidth:'95vw',maxHeight:'80vh',display:'flex',flexDirection:'column'}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <h3 style={{margin:0,fontSize:16,fontWeight:700}}>Run History — {runsModal.job.name}</h3>
              <button onClick={()=>setRunsModal(null)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:'#64748b'}}>✕</button>
            </div>
            <div style={{flex:1,overflow:'auto',padding:16}}>
              {runsModal.runs.length===0 ? (
                <div style={{textAlign:'center',padding:32,color:'#94a3b8'}}>No runs yet</div>
              ) : runsModal.runs.map(r=>{
                const sm = STATUS_META[r.status]||{color:'#64748b',bg:'#f1f5f9',label:r.status};
                return (
                  <div key={r.id} style={{border:'1px solid #e2e8f0',borderRadius:10,padding:'14px 16px',marginBottom:10}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                      <div style={{display:'flex',gap:8,alignItems:'center'}}>
                        <span style={{background:sm.bg,color:sm.color,borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700}}>{sm.label}</span>
                        <span style={{fontSize:12,color:'#64748b'}}>{ts(r.startedAt)} · by {r.triggeredBy}</span>
                      </div>
                      {r.summary && <span style={{fontSize:11,color:'#64748b'}}>✓{r.summary.success||0} ✗{r.summary.failed||0}</span>}
                    </div>
                    {r.log && <pre style={{margin:0,fontSize:11,color:'#475569',background:'#f8fafc',padding:'8px 10px',borderRadius:6,overflow:'auto',maxHeight:80}}>{r.log}</pre>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
